import bufferFactory from "_src/engine/factories/pixel_buffer";

export default {

  _map : new WeakMap(),

  initBuffer(type, params) {

    const buffer = bufferFactory.create(type, params);

    this._map.set(buffer, 0);

    return buffer;

  },

  incBufferLinkCount(buffer) {

    let count = this._map.get(buffer);
    ++count;

    this._map.set(buffer, count);

  },

  decBufferLinkCount(buffer) {

    let count = this._map.get(buffer);
    --count;

    this._map.set(buffer, count);

  },

  getBufferCount(buffer) {
    return this._map.get(buffer);
  },

}